export default "__VITE_ASSET__e0ee9edf__"